export default __webpack_public_path__ + "static/2_2-4a33f6406bc53f38f16012f20556b274.jpeg";